import {Kachel} from "../structs/Kachel";
import {SearchMap} from "./SearchMap";
import {frontIndexZ, IKachelOverlay} from "./IKachelOverlay";
import {KachelInfoBox} from "./KachelInfoBox";
import {GpsPos} from "./igps";

export interface IPriceMarker extends IKachelOverlay {
    hover(hover: boolean): void;
}

export let PriceMarker: {
    new(kachel: Kachel, mapDiv: JQuery<HTMLElement>, map: google.maps.Map): IPriceMarker;
};

export function initPriceMarkerClass() {
    PriceMarker = class extends google.maps.OverlayView {
        readonly latlng: google.maps.LatLng;
        readonly kachel: Kachel;
        readonly mapDiv: JQuery<HTMLElement>;
        readonly map: google.maps.Map;

        div: JQuery<HTMLElement> | null = null;
        width: number = 0;
        height: number = 65;

        constructor(kachel: Kachel, mapDiv: JQuery<HTMLElement>, map: google.maps.Map) {
            super();
            const pos = new GpsPos(kachel.map_pos);
            this.latlng = pos.google();
            this.kachel = kachel;
            this.mapDiv = mapDiv;
            this.map = map;
            this.setMap(map);
        }

        hover(hover: boolean) {
            if (!this.div) return;
            if (hover) frontIndexZ(this.div).addClass('over'); else this.div.removeClass('over');
        }

        updatePos() {
            if (!this.div) return;
            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            if (point) {
                this.div.css({left: point.x, top: point.y - this.height});
            }
        }

        draw() {
            if (!this.div) {
                this.div = this.generateDiv(div => {
                    this.width = div.outerWidth(true);
                    this.height = div.outerHeight(true);
                    this.updatePos();
                })
                this.getPanes().overlayMouseTarget.appendChild(this.div[0]);
            }

            this.updatePos();
        }

        private generateDiv(resizeCall: (div: JQuery<HTMLElement>) => void): JQuery<HTMLElement> {
            const div = $('<div class="marker-wrapper">' +
                '  <div class="marker text-center"><span>' + this.kachel.map_price.substring(0, 4) + '</span><span class="rental-amount">' + this.kachel.map_price.substring(4) + '</span></div>' +
                '  <div class="triangle" />' +
                '</div>');

            div.on("mouseover", () => SearchMap.hoverMarker(this.kachel.target));
            div.on("mouseout", () => SearchMap.hoverMarker(0));

            div.on("click", (ev) => {
                SearchMap.updateInfoBox(new KachelInfoBox(this))
            });

            setTimeout(() => resizeCall(div), 0);

            return div;
        }

        remove() {
            if (this.div) {
                this.setMap(null);
                this.div.remove();
                this.div = null;
            }
        }
    };
}
